// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__1b2i7","col":"styles_col___AiOn"};